/**
 * The AI credits the sidebar footer shows (Figma `AI credits`, 2130:59087).
 *
 * The frame's own numbers — "2,137 left" over a bar at 80% — so the prototype
 * opens on exactly what the design draws, and the allowance is what makes
 * 2,137 read as 80%.
 *
 * One credit per answer DeepDive AI generates (the user's call, 2026-09-21):
 * a question, in a new chat or an existing one, and a Regenerate each cost
 * one. Fast and Expert cost the same, since nothing in the design prices them
 * apart. Spent credits are session state in `ChatContext`, beside the answers
 * that spent them.
 */
export const AI_CREDITS_TOTAL = 2671;
export const AI_CREDITS_AT_START = 2137;
